export default __webpack_public_path__ + "6c72e0035c1e4382da7bedc00a0d50be.png";